import React from "react";
import PropTypes from "prop-types";
import { path } from "ramda";
import { connect } from "react-redux";
import { ReducerKeys } from "../reducers";
import Layout from "../components/layout/Layout";
import ContentBox from "../components/layout/ContentBox";
import I18n from "../i18n";
import AppearancePanel from "./SettingPanels/Appearance";
import AccountForm from "./SettingPanels/AccountForm";
import UserUtil from "../util/user";

const Setting = (props, context) => {
	const { user:{roles}, organization } = props;
	const isSuperAdmin = UserUtil.isRole(roles, UserUtil.Roles.OrganizationSuperAdmin) || UserUtil.isRole(roles, UserUtil.Roles.SuperAdmin);
	return (<Layout>
		{isSuperAdmin ? <AppearancePanel organization={props.organization} /> : undefined}
		<ContentBox.Box organization={props.organization} nodivider>
			<AccountForm />
		</ContentBox.Box>
	</Layout>);
};

function state2props(state){
	return {
		user: path([ReducerKeys.USER,"user"],state),
		organization: path([ReducerKeys.ORGANIZATION, "organization"], state)
	};
}
export default connect(state2props)(Setting);


// WEBPACK FOOTER //
// ./src/containers/Setting.js